<div><strong>ALSO KNOWN AS:</strong></div>
<div><textarea class="form-control ndc-akas p-0" value="{{akas | joinList:', ':''}}" readonly> </textarea></div>
